import { COLORS } from "@/constants";

// Rendered from main.tsx (outside App and all providers) while a cold start
// waits on the hostname→tenant lookup, so the member sees a branded splash
// instead of a blank page for up to TENANT_RESOLVE_TIMEOUT_MS.
export const TenantResolvingScreen = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: 12,
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100dvh",
      color: COLORS.text.pagePrimary,
      backgroundColor: COLORS.background.bodyDefault,
    }}
  >
    <style>
      {"@keyframes tenant-resolving-spin { to { transform: rotate(360deg); } }"}
    </style>
    <div
      aria-label="Loading"
      style={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        border: `3px solid ${COLORS.text.pagePrimary}`,
        borderTopColor: "transparent",
        animation: "tenant-resolving-spin 0.8s linear infinite",
      }}
    />
    <div>Loading...</div>
  </div>
);
